import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-authentication',
  templateUrl: './profile-authentication.component.html',
  styleUrls: ['./profile-authentication.component.scss']
})
export class ProfileAuthenticationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
